/**
 * Who may speak first on this page load.
 *
 * The proactive decide tick (boot page-view, SPA navigation, dwell /
 * scroll / exit moments) asks the server for a move: a composed opening,
 * a bubble rewrite, a content open. Two things stand it down for the
 * whole page load:
 *
 *   - an Action engaged (click or arrival) — the Action is the one
 *     proactive act this page gets;
 *   - a LIVE VOICE CALL — the bot already owns the conversation and
 *     speaks the arrival itself (#645); with the panel open every
 *     bubble rewrite is invisible, so each tick would be a wasted model
 *     call (voice run 2026-10-18: two rewrites fired on /pricing mid-call,
 *     seen by nobody).
 *
 * Pure so it can be tested without a DOM.
 */
export function proactiveTickAllowed(s: { actionEngaged: boolean; voiceLive: boolean }): boolean {
  if (s.actionEngaged) return false;
  if (s.voiceLive) return false;
  return true;
}

/**
 * May an ARRIVAL OFFER (a campaign interstitial / banner / toast matched
 * by /discover for this page) present on this page load?
 *
 * Not over a live conversation (David 2026-10-26: "offers are firing
 * over live chats"). A visitor mid-chat who lands on a page with an
 * arrival offer configured was getting the campaign takeover on top of
 * the conversation they were having — the offer is its own conversation
 * and does not connect to the one in progress. While a chat resumed
 * across the navigation or a call is live, the offer stands down; the
 * agent can raise it itself in the conversation (a tool-call path, to
 * be designed). Pure so it can be tested without a DOM.
 */
export function arrivalOfferAllowed(s: {
  conversationResumed: boolean;
  voiceLive: boolean;
}): boolean {
  if (s.conversationResumed) return false;
  if (s.voiceLive) return false;
  return true;
}

/**
 * A call is live when the voice machine is anywhere but idle, or when
 * this page load is resuming a call that survived the navigation (the
 * resume starts asynchronously; the boot tick must not race it).
 */
export function voiceIsLive(voiceStateName: string, resumingVoice: boolean): boolean {
  return voiceStateName !== 'idle' || resumingVoice;
}
